import React from 'react';
import { useParams } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { RequireUser } from '../../../../common/RequireUser';
import { getRobotsValue } from '../../../../services/utils';
import { PurchasePage } from './PurchasePage';
import { useServiceProvider } from '../../../../common/Providers';
import { SuccessPage } from './SuccessPage';
import { useSelector } from 'react-redux';
import { RootState } from '@lialo/core/lib/store/root';
import { tourDetailSelectors } from '@lialo/core/lib/pages/tourDetail';
import { PurchaseCouponInfo } from '@lialo/payment/lib/checkout/coupon';

interface IProps {}

export const PurchaseCouponPage = (props: IProps) => {
  const { navigationService, analyticsService } = useServiceProvider();
  const { tourCode } = useParams<{ tourCode: string }>();
  const tour = useSelector(tourDetailSelectors.selectTourDetails);

  const [response, setResponse] = React.useState<PurchaseCouponInfo | null>(null);

  const onSuccess = (response: PurchaseCouponInfo) => {
    analyticsService.logPaymentCompleted(
      tourCode,
      response.paymentMethod,
      tour?.price,
      tour?.user?.id,
      tour?.startLocation?.city
    );
    analyticsService.logPurchase(
      tourCode,
      tour?.title,
      tour?.price,
      undefined,
      tour?.price,
      response.orderId ?? undefined,
      tour?.user?.id,
      tour?.startLocation?.city
    );

    setResponse(response);
  };

  return (
    <>
      <Helmet>
        <meta name="robots" content={getRobotsValue('noindex,nofollow')} />
      </Helmet>
      <RequireUser parentUrl={navigationService.generateTourDetailUrl(tourCode)}>
        {response ? (
          <SuccessPage info={response} />
        ) : (
          <PurchasePage tourCode={tourCode} onSuccess={onSuccess} />
        )}
      </RequireUser>
    </>
  );
};
